import { ILLGenericKeys } from './ll-generic-keys.model';
import { Media } from './media.model';
import { OrderUser } from './order-user.model';
import { OrderComment } from './order-comment.model';
import { enWorkflowStatus } from './workflow-status.model';

export class Order {
    majorRevision: number;
    minorRevision: number;
    workFlowStatus: enWorkflowStatus;
    workFlowOrderId: number;
    orderRevisionId: number;
    orderId: number;
    baselineOrderId: number;
    nonChargeableFlag: boolean;
    deliveryPriority: string;
    splService: ILLGenericKeys;
    orderStatus: string;
    actualDeliveryDate: Date;
    confirmedDueDate: Date;
    billable: boolean;
    productName: string;
    dataCollectionForm: number;
    completedSPL: number;
    textSelectable: boolean;
    additionalInformation: string;
    acctMgrInstructions: string;
    sourceDocuments: Media[];
    orderUsers: OrderUser[];
    comments: string;
    commentsChangeUser: string;
    commentsChangeDate: Date;
    orderComments: OrderComment[];
    externalTrackingNumber: string;
    orderName: string;
    colOrDrugFactChangeInstruction: string;
    principalDisplayPanelChangeInstruction: string;
    LLMetadataChangeInstruction: string;
    orderDescription: string;
    serviceCategory: string;
    isDraftMode: boolean;
    isDeleted: boolean;
    beforeOrderStatus: string;
    beforeConfirmedDate: Date;
    baselineWorkFlowOrderId: number;
    serviceGroup: string;
    country: string;
}

